// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text--jackpot[data-v-4c583df0] {\n  background-color: var(--magic-primary, #6c5dd3);\n}\n\n[data-v-4c583df0].text--promotion ol {\n  margin: var(--magic-space, 16px) auto;\n}\n[data-v-4c583df0].text--promotion ol li::before {\n  border-radius: 50%;\n}", ""]);
// Exports
module.exports = exports;
